var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "cargo-area" + (_vm.notClick ? " not-click" : "") },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("CargoMsg.Cargo_Province"),
            required: _vm.isRequired,
            "label-width": _vm.provinceLabelWidth
              ? _vm.provinceLabelWidth + "px"
              : _vm.labelWidth + "px"
          }
        },
        [
          _c("cargo-advance-select", {
            style: {
              width:
                typeof _vm.selectWidth === "number"
                  ? _vm.selectWidth + "px"
                  : _vm.selectWidth
            },
            attrs: {
              "allow-create": _vm.allowCreate,
              filterable: _vm.filterable,
              "select-type":
                _vm.selectTypeNames.basic_data_AdministrativeDivision,
              "callback-params": { key: "code" },
              "default-value": _vm.innerProvince,
              disabled: _vm.provinceDisabled,
              "static-options": _vm.provinceList,
              "tag-name": "name",
              "tag-value": "code",
              placeholder: _vm.placeholder,
              fields: ["code"]
            },
            on: { parentCallBack: _vm.provinceChangeHandler }
          })
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.cityLabelName
              ? _vm.cityLabelName
              : _vm.$t("CargoMsg.Cargo_city"),
            required: _vm.isRequired,
            "label-width": _vm.cityLabelWidth
              ? _vm.cityLabelWidth + "px"
              : _vm.labelWidth + "px"
          }
        },
        [
          _c("cargo-advance-select", {
            ref: "city",
            style: {
              width:
                typeof _vm.selectWidth === "number"
                  ? _vm.selectWidth + "px"
                  : _vm.selectWidth
            },
            attrs: {
              "allow-create": _vm.allowCreate,
              filterable: _vm.filterable,
              "select-type":
                _vm.selectTypeNames.basic_data_AdministrativeDivision,
              "callback-params": { key: "code" },
              "default-value": _vm.innerCity,
              disabled: _vm.cityDisabled,
              "static-options": _vm.cityList,
              "tag-name": "name",
              "tag-value": "code",
              placeholder: _vm.placeholder,
              fields: ["code"]
            },
            on: { parentCallBack: _vm.cityChangeHandler }
          })
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.districtLabelName
              ? _vm.districtLabelName
              : _vm.$t("CargoMsg.Cargo_District"),
            required: _vm.isRequired,
            "label-width": _vm.districtLabelWidth
              ? _vm.districtLabelWidth + "px"
              : _vm.labelWidth + "px"
          }
        },
        [
          _c("cargo-advance-select", {
            ref: "district",
            style: {
              width:
                typeof _vm.selectWidth === "number"
                  ? _vm.selectWidth + "px"
                  : _vm.selectWidth
            },
            attrs: {
              "allow-create": _vm.allowCreate,
              filterable: _vm.filterable,
              "select-type":
                _vm.selectTypeNames.basic_data_AdministrativeDivision,
              "callback-params": { key: "code" },
              "default-value": _vm.innerDistrict,
              disabled: _vm.districtDisabled,
              "static-options": _vm.districtList,
              "tag-name": "name",
              "tag-value": "code",
              placeholder: _vm.placeholder,
              fields: ["code"]
            },
            on: { parentCallBack: _vm.districtChangeHandler }
          })
        ],
        1
      ),
      _vm.showTown
        ? _c(
            "el-form-item",
            {
              style: _vm.townStyle,
              attrs: {
                label: _vm.townLabelName
                  ? _vm.townLabelName
                  : _vm.$t("CargoMsg.Cargo_StreetTownship"),
                required: _vm.isRequired,
                "label-width": _vm.townLabelWidth
                  ? _vm.townLabelWidth + "px"
                  : _vm.labelWidth + "px"
              }
            },
            [
              _c("cargo-advance-select", {
                ref: "town",
                style: {
                  width:
                    typeof _vm.selectWidth === "number"
                      ? _vm.selectWidth + "px"
                      : _vm.selectWidth
                },
                attrs: {
                  "allow-create": _vm.allowCreate,
                  filterable: _vm.filterable,
                  "callback-params": { key: "uuid" },
                  "default-value": _vm.innerTown,
                  disabled: _vm.townDisabled,
                  "static-options": _vm.townList,
                  "tag-name": "name",
                  "tag-value": "uuid",
                  placeholder: _vm.placeholder,
                  fields: ["uuid"],
                  "filter-tag-names": ["name"]
                },
                on: { parentCallBack: _vm.townChangeHandler }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }